<script lang="ts" setup>
import ShortProfile from '@/api/Main/dataSource/api/users/profile/i-service/models/ShortProfile';
import {
  TirPmButton,
  TirPmButtonSizeEnum,
  TirPmButtonVariantEnum,
  TirPmIconView,
  TirPmInput,
  TirPmNotificationEventBus,
  TirPmNotificationModel,
  TirToggle,
} from 'tir-components';
import { computed, nextTick, onMounted, ref, watch } from 'vue';

import ApiService from '@/api';
import { PhotoIcon } from 'tir-style-system/icons/outline';
import { useRouter } from 'vue-router';

import { TirPmCropper, TirCropperVarsModel, CropSelectionModel } from 'tir-pm-cropper';
import { CurrentUser, UserRoleEnum } from 'tir-pm-user-core';
import { FotoRequest, ProjectDataModel } from './models';
import { BaseProjectResponse } from '@/components/task-forms/components/task-copying-modal/models';
import { EnumProjectType } from './enums';
import { ProjectNoSaveModal, ProjectSettingsSkeleton } from './components';
TirCropperVarsModel.setVars(new TirCropperVarsModel());

const api = new ApiService();

/**Параметры */
const props = defineProps({
  /**Доступ к weeek */
  isAccessWeeek: { type: Boolean },
});

const emit = defineEmits<{
  /**Обновление проекта */
  uppdateProject: [];
  /**Обновление разрешения для импорта с weeek */
  updateAllowImportWeeek: [state: boolean];
}>();

/**
 * Переменная для поиска по юзерам в модалке
 */
const searchStringForUser = ref('');

const copiedEditData = ref<BaseProjectResponse>();
/**url новой фотки */
const urlNewImage = ref();
/**Разрешение на редактирование */
const permissionEdit = ref(false);
/**Изначальные данные проекта */
const initialProjectData = ref<ProjectDataModel>();
/**Статус проекта */
const projectStatus = ref<EnumProjectType>();
/**Загрузка */
const isLoading = ref<boolean>();
/**Видимость окна подтверждения выхода */
const isVisibleModal = ref(false);
/**Загрузка проекта */
const isLoadingProject = ref(false);
/**состояние импорта weeek */
/**Сохранено фото */
const isSavePhoto = ref<boolean>();
const weeekState = ref();
const currentPhotoProject = ref(null);
const currentPhotoProjectSetting = ref<CropSelectionModel>();
const sendFileInput = ref(null);
const isOpenCropper = ref(false);
const croppedNewPhoto = ref();

const editProjectName = ref<string>();
const src = ref();
/**Данные проекта */
const currentProjectData = ref<ProjectDataModel>(
  new ProjectDataModel({
    Name: '',
  }),
);
/**Статус проекта */
const projectStatusBoolean = computed<boolean>({
  get: () => currentProjectData.value.Status === 0,
  set: (state: boolean) => {
    currentProjectData.value.Status = state ? 0 : 1;
  },
});
/**Произошли ли изменения в настройках проекта */
const isProjectSettingsChanged = computed(() => {
  const current = JSON.stringify(currentProjectData.value);
  const initial = JSON.stringify(initialProjectData.value);

  return current == initial;
});
/**Надпись в зависимости от статуса проекта */
const projectStatusLabel = computed(() => {
  return !currentProjectData.value.Status
    ? 'Проект активен: можно создавать тикеты, пользователи будут видеть уведомления об изменениях'
    : 'Проект помещен в Архив: пользователи не видят задач, все уведомления по задачам для всех выключены';
});
/**
 * Сохранить загруженную фотку
 */
const onSaveFile = (e) => {
  if (e.target.files.length) {
    let reader = new FileReader();
    reader.readAsDataURL(e.target.files[0]);
    reader.onload = function () {
      isOpenCropper.value = true;
      currentPhotoProject.value = reader.result as string;
      urlNewImage.value = reader.result as string;
      // croppedNewPhoto.value = reader.result as string;
    };
    reader.onerror = function (error) {
      console.log('Error: ', error);
    };
  }
};
const onCroppedPhoto = (croppedPhoto) => {
  croppedNewPhoto.value = croppedPhoto;
  currentProjectData.value.Image = new FotoRequest({
    ...currentProjectData.value.Image,
    Image: currentPhotoProject.value,
  });
};
const onCloseCropper = () => {
  permissionEdit.value = true;
  isOpenCropper.value = false;
};
const chosePhoto = () => {
  sendFileInput.value.click();
};
/**Текущее название проекта */
let currentEditProjectName = null;

/**Проверка на изменение в инпуте  */
const isInputModified = () => {
  nextTick(() => {
    permissionEdit.value = editProjectName.value !== currentEditProjectName;
  });
};

const onCropPhoto = (cropData: CropSelectionModel) => {
  sendFileInput.value.value = null;
  currentPhotoProjectSetting.value = cropData;
  currentProjectData.value.Image = new FotoRequest({
    Height: cropData.Height,
    Width: cropData.Width,
    Left: cropData.X,
    Top: cropData.Y,
  });
};

// Переменная для списка пользователей, чтобы назначить из него админом или участником для селекта
const UserList = ref<Array<ShortProfile>>([]);

const selectedAdminUsers = ref<Array<ShortProfile>>([]);
const copiComparedUserList = ref<Array<ShortProfile>>([]);
const computedNameCompareFoto = (admin: ShortProfile) => {
  return admin.FirstName[0].toUpperCase() + admin.LastName[0].toUpperCase();
};

const loadProjects = async () => {
  let { Items } = await api.Main.PerformersListService.getOwnedUsersAsync({
    StatusList: [1],
    Search: '',
    Page: {
      Skip: 0,
      Take: 1000,
    },
  });
  UserList.value = Items;
  copiComparedUserList.value = UserList.value;
};

// Функция для фильтрации юзеров
const filteredUser = (selectedUserName?: ShortProfile & string) => {
  copiComparedUserList.value = UserList.value;
  copiComparedUserList.value = copiComparedUserList.value.filter(
    (x) => !selectedAdminUsers.value.find((y) => y.UserId == x.UserId),
  );
  if (typeof selectedUserName == 'string' && selectedUserName.length) {
    copiComparedUserList.value = copiComparedUserList.value.filter((x) => {
      let compairedString = x.FirstName + ' ' + x.MiddleName + ' ' + x.MiddleName;
      return compairedString.includes(selectedUserName);
    });
  }
};

const computedAdminListForRender = (adminList: Array<ShortProfile>) => {
  let newAdminList;
  if (adminList.length > 5) {
    newAdminList = adminList.slice(0, 5);
    return newAdminList;
  } else {
    return adminList;
  }
};

// Функция для выбора юзера для селекта администраторы
const setAdminToProject = (selectedUser: ShortProfile) => {
  selectedAdminUsers.value.push(selectedUser);
  filteredUser();
  searchStringForUser.value = '';
};
/**Подтверждение выхода из окна */
const confirmLeave = () => {
  currentProjectData.value.Name = initialProjectData.value.Name;
  currentProjectData.value.Image = initialProjectData.value.Image;
  currentProjectData.value.WeeekEnable = initialProjectData.value.WeeekEnable;
  currentProjectData.value.Status = initialProjectData.value.Status;
};

// Функция для удаления юзера для селекта администраторы
const removeAdminForProject = (removedAdmin: ShortProfile) => {
  selectedAdminUsers.value = selectedAdminUsers.value.filter(
    (x) => x.UserId !== removedAdmin.UserId,
  );
  filteredUser();
};
/**Изменение видимости окна подтверждения  выхода */
const toggleVisibleModal = (state: boolean) => {
  isVisibleModal.value = state;
};
// Сохранить модалку редактирования
const saveModalEditEmployee = async () => {
  isLoading.value = true;

  if (!copiedEditData.value.Id) {
    isLoading.value = false;
    return;
  }

  try {
    // Emit если флаг weeek изменился
    if (initialProjectData.value.WeeekEnable !== currentProjectData.value.WeeekEnable) {
      emit('updateAllowImportWeeek', weeekState.value);
    }

    const payload: any = {
      Id: copiedEditData.value.Id,
      Name: currentProjectData.value.Name,
      AdminsIds: editProjectName.value.AdminsIds,
      Status: currentProjectData.value.Status,
      Types: [],
    };

    const currentImage = currentProjectData.value.Image?.Image;
    const initialImage = initialProjectData.value.Image?.Image;

    const imageChanged = currentImage && currentImage !== initialImage;

    if (imageChanged) {
      payload.Image = new FotoRequest({
        Height: currentProjectData.value.Image.Height,
        Width: currentProjectData.value.Image.Width,
        Left: currentProjectData.value.Image.Left,
        Top: currentProjectData.value.Image.Top,
        Image: currentImage,
      });
    }

    await api.Main.ProjectBaseService.updateAsync(payload);

    emit('uppdateProject');

    TirPmNotificationEventBus.emit(
      'add',
      new TirPmNotificationModel({
        title: 'Успешное редактирование',
        type: 'success',
        group: 'general',
        life: 5000,
        closable: true,
        callbackButton: () => {},
      }),
    );

    isOpenCropper.value = false;

    // Обновляем initialProjectData
    initialProjectData.value = new ProjectDataModel({
      Image: currentProjectData.value.Image,
      Name: currentProjectData.value.Name,
      Status: currentProjectData.value.Status,
      WeeekEnable: currentProjectData.value.WeeekEnable,
    });
  } catch (err: unknown) {
    console.log(err, 'error new');

    const errorMessage =
      typeof err === 'object' && err && 'ErrorMessage' in err
        ? (err as any).ErrorMessage
        : 'Произошла ошибка при сохранении';

    TirPmNotificationEventBus.emit(
      'add',
      new TirPmNotificationModel({
        title: errorMessage,
        type: 'error',
        group: 'general',
        life: 5000,
        closable: true,
        callbackButton: () => {},
      }),
    );
  } finally {
    permissionEdit.value = false;
    isLoading.value = false;
  }
};

/**Обновление состояние weeek */
const changeWeeekState = (state: boolean) => {
  weeekState.value = state;
};

const route = useRouter();

onMounted(async () => {
  isLoadingProject.value = true;
  try {
    copiedEditData.value = await api.Main.ProjectBaseService.getIdAsync({
      ProjectId: Number(route.currentRoute.value.params.projectId),
    });

    croppedNewPhoto.value = copiedEditData.value?.ImageUrl;
    projectStatus.value = copiedEditData.value.Status;
    weeekState.value = copiedEditData.value.WeeekEnable;
    editProjectName.value = copiedEditData.value.Name;
    currentEditProjectName = copiedEditData.value.Name;
    await loadProjects();
  } catch {}
  currentProjectData.value = new ProjectDataModel({
    Image: new FotoRequest({
      Image: croppedNewPhoto.value,
    }),
    Name: copiedEditData.value.Name,
    Status: projectStatus.value,
    WeeekEnable: weeekState.value,
  });
  initialProjectData.value = new ProjectDataModel({
    Image: new FotoRequest({
      Image: croppedNewPhoto.value,
    }),
    Name: copiedEditData.value.Name,
    Status: projectStatus.value,
    WeeekEnable: weeekState.value,
  });
  isLoadingProject.value = false;
});
</script>
<template>
  <div class="project-main-settings-page">
    <div class="project-main-settings-page__header">
      <h2 class="project-main-settings-page__title">Основная информация</h2>
      <TirPmButton
        :isLoading="isLoading"
        :variant="TirPmButtonVariantEnum.PrimaryState"
        :size="TirPmButtonSizeEnum.Small"
        :isDisabled="isProjectSettingsChanged || isLoadingProject || isOpenCropper"
        @click="saveModalEditEmployee"
      >
        Сохранить
      </TirPmButton>
    </div>
    <ProjectSettingsSkeleton v-if="isLoadingProject" />
    <div v-else class="project-main-settings-page__content">
      <div class="project-main-settings-page__head">
        <div
          v-if="!isOpenCropper"
          @click="
            () => {
              !isOpenCropper && CurrentUser.Roles.includes(UserRoleEnum.Owner)
                ? chosePhoto()
                : null;
            }
          "
        >
          <TirPmIconView :size="128" isRounded :isBordered="!isOpenCropper && !currentPhotoProject">
            <template #mainSlot>
              <PhotoIcon style="width: 5rem; height: 5rem"></PhotoIcon>
              <img :src="croppedNewPhoto" v-if="croppedNewPhoto" alt="" />
            </template>
          </TirPmIconView>
        </div>
        <div
          class="project-main-settings-page__cropper"
          v-if="isOpenCropper && currentPhotoProject"
        >
          <TirPmCropper
            v-model="currentPhotoProject"
            :src="currentPhotoProject"
            @crop="onCropPhoto"
            @save="onCloseCropper"
            @choseOtherPhoto="chosePhoto"
            @onCroppedPhoto="onCroppedPhoto"
          />
        </div>
        <div class="project-modal__head-controls">
          <input
            type="file"
            ref="sendFileInput"
            @change="onSaveFile"
            accept="image/png, image/gif, image/jpeg, .jpg"
            style="display: none"
          />
          <TirPmButton
            @click="chosePhoto"
            v-if="
              croppedNewPhoto && !isOpenCropper && CurrentUser.Roles.includes(UserRoleEnum.Owner)
            "
            :size="TirPmButtonSizeEnum.Small"
            :variant="TirPmButtonVariantEnum.SecondaryState"
            >Редактировать фото
          </TirPmButton>
        </div>
      </div>
      <TirPmInput
        v-model="currentProjectData.Name"
        @input="isInputModified"
        :isDisabled="!CurrentUser.Roles.includes(UserRoleEnum.Owner)"
        placeholder="Лучший проект на свете :)"
        label="Название проекта"
        :is-with-hint="false"
      />
      <div class="project-main-settings-page__switches">
        <div class="project-main-settings-page__switch">
          <TirToggle v-model="projectStatusBoolean" />
          <div>
            <div class="project-main-settings-page__switch-title">Активный проект</div>
            <div class="project-main-settings-page__switch-paragparh">
              {{ projectStatusLabel }}
            </div>
          </div>
        </div>
        <div class="project-main-settings-page__switch">
          <TirToggle
            v-model="currentProjectData.WeeekEnable"
            @update:model-value="changeWeeekState"
          />
          <div>
            <div class="project-main-settings-page__switch-title">Разрешить импорт с weeek</div>
            <div class="project-main-settings-page__switch-paragparh">
              Дополнительная опция при создании тикетов, позволяющаяя импртировать задачи с weeek.ru
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <ProjectNoSaveModal
    :visible="isVisibleModal"
    :isProjectSettingsChanged="isProjectSettingsChanged"
    @toggleVisibleModal="toggleVisibleModal"
    @confirmLeave="confirmLeave"
  />
</template>
<style lang="scss" scoped>
@use 'sass:map';

@import 'tir-style-system/expose-variables';
@import 'tir-style-system/expose-default-theme';
@import 'tir-style-system/core/mixins';

.project-main-settings-page {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  &__title {
    margin: 0;
    font-size: 1.25rem;
    font-weight: 600;
    line-height: 1.75rem;
  }
  &__switches {
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
  }
  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  &__switch-title {
    font-size: 1rem;
    font-weight: 400;
  }
  &__switch-paragparh {
    font-size: 0.75rem;
    font-weight: 400;
    color: var(--text-secondary, #686c73);
    margin-top: 0.25rem;
  }
  &__switch {
    display: flex;
    gap: 0.75rem;
  }
  &__content {
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }
  &__head {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    width: fit-content;
    align-items: center;
    max-width: 31.25rem;
  }
  &__controls {
    max-width: 31.25rem;
  }
  &__controls {
    margin-top: 3rem;
  }
}

.selected-budge-list {
  display: flex;
  gap: 0.125rem;
  flex-wrap: wrap;
}

.selected-budge {
  padding: 0.125rem 0.5rem;
  display: flex;
  align-items: center;
  gap: 0.375rem;
  border-radius: 0.25rem;
  min-height: 1.75rem;
  width: fit-content;
  background-color: var(--neutral-translucent-20, map.get($colors, 'neutral-translucent-20'));
  &--types {
    background-color: var(--neutral-translucent-10, map.get($colors, 'neutral-translucent-10'));
  }
  &__left-slot {
  }
  &__sign {
    font-size: 0.875rem;
    line-height: 1.25rem;
    color: var(--text-primary, map.get($colors, 'text-primary'));
    white-space: nowrap;
  }
  &__divider {
    height: 1rem;
    width: 0.063rem;
    background-color: var(--text-tertiary, map.get($colors, 'text-tertiary'));
  }
  &__close-button {
    color: var(--text-tertiary, map.get($colors, 'text-tertiary'));
    transition: 0.1s ease-in;
    display: flex;
    cursor: pointer;
    svg {
      width: 1.5rem;
      height: 1.5rem;
    }
  }
  &__close-button:hover {
    color: var(--text-primary, map.get($colors, 'text-primary'));
    svg {
      width: 1.5rem;
      height: 1.5rem;
    }
  }
}
</style>
